module.exports = __webpack_public_path__ + "static/media/background-img.7fefa6d3.svg";